import React from 'react';
import { motion } from 'framer-motion';

const StartApplicationButton = ({ onApplyNow }) => {
  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="flex items-center justify-center gap-2 rounded-md bg-gradient-to-r from-blue-500 to-green-500 px-4 py-2.5 text-sm font-medium text-white shadow-md md:px-6 md:py-3 md:text-base"
      onClick={onApplyNow}
    >
      Start Your Journey
      <span className="text-base md:text-lg">→</span>
    </motion.button>
  );
};

export default StartApplicationButton;
